import { axiosWithToken } from "@/utils/axios";

class BeneficiaryService {
  createBeneficiary(payload: any): Promise<any> {
    return axiosWithToken().post("/beneficiaries", payload);
  }

  updateBeneficiary(payload: any): Promise<any> {
    return axiosWithToken().patch("/beneficiaries", payload);
  }

  getBeneficiaries(): Promise<any> {
    return axiosWithToken().get("/beneficiaries");
  }

  getBeneficiary(id: string): Promise<any> {
    return axiosWithToken().get(`/beneficiaries/${id}`);
  }
}

export default new BeneficiaryService();
